import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Card, Modal, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import axios from "axios"; // Import axios for API calls
import "./VehicleSlider.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";


const API_URL = "https://ridehire-backend-2.onrender.com/admin/allSuccessEvent";

const VehicleSlider = () => {
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const swiperRef = useRef(null);
  console.log(events);

  // ✅ Fetch events from API
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(API_URL);
        console.log(response.data);
        setEvents(response.data.events)
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  const openModal = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.update(); // Ensure swiper updates on mount
    }
  }, [events]);

  return (
    <div className=" v1 VehicleSlider-container v1 d-flex justify-content-center">
      <div className="container w-70">
        <div className="d-flex justify-content-between align-items-center">
          <div className="">

          <h2 className="fw-bold">Popular Vehicle</h2>
          <div className="text-black-50 lorem-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
          </div>
          <button className="see-btn">See all vehicle category</button>
        </div>

        <div className="slider-container position-relative py-5">
          {/* ✅ Swiper Slider with API Data */}
          <Swiper
            ref={swiperRef}
            spaceBetween={10}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
            loop={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            grabCursor={true}
            modules={[Navigation, Autoplay]}
          >

            {events.length === 0 ? (
              <Skeleton height={250} width="100%" />
            ) : (
              events.map((event, index) => (
                <SwiperSlide key={index}>
                <Card className="event-card position-relative overflow-hidden border-0" onClick={() => openModal(event)}>
                  
                  {/* 🔹 Title Positioned on Top */}
                  <div className="card-title-overlay">
                    <h5 className="event-title">{event.event_name}</h5>
                  </div>
              
                  {/* 🔹 Image */}
                  <Card.Img
                    variant="top"
                    src={`https://ridehire-backend-2.onrender.com${event.event_img}`}
                    alt={event.event_name}
                    className="event-img"
                    loading="lazy"
                  />
                </Card>
              </SwiperSlide>
              
              ))
            )}

          </Swiper>

          {/* ✅ Left & Right Navigation Buttons */}
          <div className="swiper-button-prev "></div>
          <div className="swiper-button-next "></div>
        </div>

        {/* ✅ Full Details Popup Modal */}
        <Modal show={showModal} onHide={closeModal} centered>
          {selectedEvent && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
            >
              <Modal.Header closeButton>
                <Modal.Title>{selectedEvent.event_name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img
                  src={`https://ridehire-backend-2.onrender.com${selectedEvent.event_img}`}
                  alt={selectedEvent.event_name}
                  className="img-fluid rounded mb-3"
                />
                <p><strong>Driver:</strong> {selectedEvent.driver_name}</p>
                <p><strong>Plate Number:</strong> {selectedEvent.plate_number}</p>
                <p><strong>Bus Name:</strong> {selectedEvent.bus_name}</p>
                <p><strong>From:</strong> {selectedEvent.startLocation}</p>
                <p><strong>To:</strong> {selectedEvent.endLocation}</p>
                <p><strong>Departure:</strong> {new Date(selectedEvent.departureStartTime).toLocaleString()}</p>
                <p><strong>Arrival:</strong> {new Date(selectedEvent.departureEndTime).toLocaleString()}</p>
                <p><strong>Total Passengers:</strong> {selectedEvent.passenger_Total_Size}</p>
                <p><strong>Price per Ticket:</strong> {selectedEvent.price}</p>
                <p><strong>Total Price:</strong> {selectedEvent.total_price}</p>
                <p><strong>Description:</strong> {selectedEvent.description}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </motion.div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default VehicleSlider;
